export default __webpack_public_path__ + "static/media/discoverBooksDark.ad85b8ef.png";